var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "scroll",
      attrs: { elevation: "0", height: _vm.winsize.height - 145 },
    },
    [
      _c(
        "v-card-actions",
        { staticClass: "ma-0 pa-0" },
        [
          _c(
            "v-card",
            {
              attrs: {
                elevation: "1",
                outlined: "",
                width: "100%",
                height: _vm.winsize.height - 145,
              },
            },
            [
              _c("v-card-actions", { staticClass: "ma-0 pa-0" }, [
                _c(
                  "div",
                  _vm._l(_vm.items, function (item, value) {
                    return _c(
                      "v-card",
                      {
                        key: item,
                        style: {
                          position: "absolute",
                          "margin-left": "5px",
                          "margin-top": 110 * value + 5 + "px",
                        },
                        attrs: {
                          outlined: "",
                          height: "100px",
                          width: "200px",
                        },
                      },
                      [
                        _c(
                          "v-movable",
                          [
                            _c(
                              "v-card",
                              {
                                staticClass: "ma-1",
                                attrs: {
                                  width: "192",
                                  height: "30",
                                  elevation: "0",
                                  outlined: "",
                                },
                              },
                              [_c("v-card-actions", [_vm._v(_vm._s(item))])],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }